<template>
  <div class="row">
    <div class="col-12">
      <h2 class="titre">
        Recherche Table des valeurs
      </h2>
    </div>
  </div>
  <CriteresRechercheTabledesvaleurs @rechercher="rechercher"/>
  <ResultatRechercheTabledesValeurs :tableValeurs="tableValeurs" :isRechercheDataLoading="isRechercheDataLoading"/>
</template>


<script>

import CriteresRechercheTabledesvaleurs
  from "@/components/pilotage/Tabledesvaleurs/CriteresRechercheTabledesvaleurs.vue";
import ResultatRechercheTabledesValeurs
  from "@/components/pilotage/Tabledesvaleurs/ResultatRechercheTabledesValeurs.vue";

import {mapGetters} from "vuex";
import axios from 'axios';


export default {
  components: {
    CriteresRechercheTabledesvaleurs,
    ResultatRechercheTabledesValeurs,
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Table de Valeurs");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.rechercher();
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      isRechercheDataLoading: false,
      tableValeurs: []
    }
  },
  methods: {
    rechercher(libelleRecherche) {
      this.tableValeurs = [];
      this.isRechercheDataLoading = true;
      this.$store.dispatch("pilotage/rechercherTableValeurAvecAscAction", libelleRecherche).then((res) => {
        console.log("Venant de libellerecherche :", res.data.libelles);
        res.data.libelles.forEach((currentTV) => {
            currentTV.tableValeur.libelles.forEach((currentEnfant) => {
                let currentValeurComplete = currentEnfant;
              currentValeurComplete.cleTV = currentEnfant.tableValeur.cle;
              currentValeurComplete.description = currentEnfant.tableValeur.description;
              currentValeurComplete.aide = currentEnfant.tableValeur.aide;
              currentValeurComplete.abreviation = currentEnfant.tableValeur.abreviation;


              this.tableValeurs.push(currentValeurComplete)
            })
          })
        this.isRechercheDataLoading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>